import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./fr";

const saved = typeof window !== "undefined" ? localStorage.getItem("novaimmo-lang") : null;

// Performance : seul le français (langue par défaut) est dans le bundle initial.
// L'anglais est chargé à la demande (chunk séparé) — au switch EN ou si la
// langue sauvegardée est EN au démarrage.
let enLoaded = false;
const loadEn = async () => {
  if (enLoaded) return;
  const mod = await import(/* webpackChunkName: "i18n-en" */ "./en");
  i18n.addResourceBundle("en", "translation", mod.default, true, true);
  enLoaded = true;
};

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
  },
  lng: "fr", // démarre en FR ; bascule vers EN dès que le bundle EN est prêt (voir plus bas)
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
});

i18n.on("languageChanged", (lng) => {
  localStorage.setItem("novaimmo-lang", lng);
  document.documentElement.lang = lng;
});

// Intercepte les changements de langue pour garantir que l'anglais est chargé
// avant le rendu (aucun flash de clés manquantes).
const originalChangeLanguage = i18n.changeLanguage.bind(i18n);
i18n.changeLanguage = async (lng, ...args) => {
  if ((lng || "").startsWith("en")) await loadEn();
  return originalChangeLanguage(lng, ...args);
};

if (saved === "en") {
  // Langue sauvegardée = EN : chargement immédiat en parallèle du reste de l'app
  i18n.changeLanguage("en");
}

export default i18n;
